import React, { useState } from 'react'
import TableContent from '../../../components/TableContent'
import LicitatiiDetails from './LicitatiiDetails'
import { apiRequest } from '../../../helpers'

const url = 'agents/licitatii'
const item = 'Licitatii'
const items = 'Licitatii'

const AgentLicitatii = () => {
  const [agent, setAgent] = useState(null)
  const [refreshData, setRefreshData] = useState(null)
  const [loading, setLoading] = useState(false)

  const onAgentSelected = async selectedAgent => {
    if (selectedAgent && selectedAgent.id) {
      setLoading(true)
      try {
        // Fetch complete agent data from API
        const result = await apiRequest(process.env.REACT_APP_API + `agents/licitatii/${selectedAgent.id}`, 'GET')

        if (result.ok) {
          setAgent(result.data)
        } else {
          console.error('Failed to fetch agent details')
          setAgent(null)
        }
      } catch (error) {
        console.error('Error fetching agent details:', error)
        setAgent(null)
      }
      setLoading(false)
    } else {
      setAgent(null)
    }
  }

  return (
    <>
      <TableContent url={url} type={'agent-licitatii'} item={item} items={items} onRowSelect={onAgentSelected} refreshData={refreshData} />
      {loading && <div style={{ textAlign: 'center', padding: '20px' }}>Loading agent details...</div>}
      {agent && !loading && <LicitatiiDetails agent={agent} refreshData={setRefreshData} />}
    </>
  )
}

export default AgentLicitatii
